// extracted by mini-css-extract-plugin
export default {"active":"navbar_active__c22XF"};